const render = () => {
    return `
        {% if isDebugger %}
            <script src="https://statics-cdn-cn.umucdn.cn/common/vconsole.min.js?v=3.2.0_{{pageData.version | default(0)}}"></script>
            <script>new VConsole();</script>
        {% endif %}
    `;
};

export default render;
